import { FC, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Home.scss";
import MasterPage from "../MasterPage/MasterPage";
import { Card, CardBody, Col, Row } from "react-bootstrap";
import { useStyle } from "../../providers/StyleProvider";
import { useSidebarFilter } from "../../providers/SidebarFilterProvider";
import { useUsers } from "../../providers/Access/Users/UsersProvider";
import { useAuth } from "../../providers/AuthProvider";

interface HomeProps {}

const Home: FC<HomeProps> = () => {
  const navigate = useNavigate();
  const { userLogged } = useAuth();
  const { style } = useStyle();
  const { showSidebarFilter, setShowSidebarFilter } = useSidebarFilter();
  const { handleStatusTutorial } = useUsers();

  useEffect(() => {
    if (
      ((userLogged?.access_profile_id === 8 || userLogged?.id === 3) && userLogged?.role === 'admin') ||
      userLogged?.partner_code === 'SP18-11074'
    ) {
      navigate('/dashboards/productivity');
    }
  }, [userLogged, navigate]);

  useEffect(() => {
    handleStatusTutorial();
  }, []);

  useEffect(() => {
    if (showSidebarFilter) {
      setShowSidebarFilter(false);
    }
  }, [showSidebarFilter]);

  return (
    <MasterPage
      title={""}
      icon={"fas fa-home"}
      heightClass="min-height-470"
      footerFixed
    >
      <div className="Home" data-testid="Home">
        <Row>
          <Col md={12}>
            <div className="d-flex align-items-center justify-content-between mb-4 mt-4">
              <div>
                <h4 className="text-white m-0">
                  Bem-vindo ao <b>BeviAjuda</b>
                </h4>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Card className="h-100">
              <CardBody className="text-center h-card">
                <div className="d-flex flex-column align-items-center justify-content-center h-100">
                  <img
                    alt={style?.name}
                    src={`${process.env.PUBLIC_URL}/assets/img/bevi-ajuda-blue.svg`}
                    className="logo"
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </MasterPage>
  );
};

export default Home;
